/**
 * doc https://www.npmjs.com/package/vue-cookie
 */
import Vue from 'vue'
import VueCookies from 'vue-cookie'

Vue.use(VueCookies)
